import { attributesToProps, domToReact } from 'html-react-parser';
//@ts-ignore
import React from 'react';

export const responsiveTextParseOptions = {
  // eslint-disable-next-line consistent-return
  // @ts-ignore
  replace: (domNode) => {
    const { attribs, children, name } = domNode;
    if (attribs) {
      const props = attributesToProps(attribs);

      let fontSize = props.style?.fontSize;

      // If it's a header, setting the font size in pt
      if (!fontSize && ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(name)) {
        switch (name) {
          case 'h1':
            fontSize = '24pt';
            break;
          case 'h2':
            fontSize = '18pt';
            break;
          case 'h3':
            fontSize = '14pt';
            break;
          case 'h4':
            fontSize = '12pt';
            break;
          case 'h5':
            fontSize = '10pt';
            break;
          case 'h6':
            fontSize = '8pt';
            break;

          default:
            break;
        }
      }

      if (fontSize) {
        const sizeNumber = Number(fontSize.match(/\d+/)?.[0]);

        // Font size comes in points (65pt, for example). So we are checking what range is the font size in and assigning a class to the component to be able to resize it on smaller screens
        // Also converting pt to px: 1 pt = 1.33 px.
        if (sizeNumber) {
          const fs = sizeNumber * 1.33;
          props.style = {
            ...props?.style,
            fontSize: `${fs}px`,
          };
          // Setting 70px as the maximum number
          if (fs > 70) {
            props.className = 'header1';
          } else if (fs > 60) {
            props.className = 'header2';
          } else if (fs > 50) {
            props.className = 'header3';
          } else if (fs > 40) {
            props.className = 'header4';
          } else if (fs > 30) {
            props.className = 'header5';
          } else if (fs > 20) {
            props.className = 'header6';
          } else {
            props.className = 'header7';
          }
        }
        const Tag = name;

        return <Tag {...props}>{domToReact(children, responsiveTextParseOptions)}</Tag>;
      }
    }
  },
};
